/* eslint-disable no-open-modules-imports */

import type { FeatureGroup } from 'feature/feature-helpers';
import { COMPOSITE, SECTION } from 'feature/feature-helpers';
import { ArticleManagerFeature } from 'open-modules/zdf/feature/editorial-dash/article-manager';
import { ChannelSelectionFeature } from 'open-modules/zdf/feature/editorial-dash/display-channel-selection';
import { t } from 'util/stdtypes';

import { InstanceManagerFeature } from './question-topic-manager';
import { SpacesFeature } from './spaces';
import { AudienceInputTemplateFeature } from './templates/audience-input-template';
import { CommentSliderTemplateFeature } from './templates/comment-slider-template';
import { ConversationHelperTemplateFeature } from './templates/conversation-helper-template';
import { DialogueTemplateFeature } from './templates/dialogue-template';
import { RepresentingPerspectivesTemplateFeature } from './templates/representing-perspectives-template';

export const editorialDashFeatures: FeatureGroup[] = [
    SECTION(t('Tabs'), [
        InstanceManagerFeature,
        ArticleManagerFeature,
        COMPOSITE(SpacesFeature, [
            CommentSliderTemplateFeature,
            RepresentingPerspectivesTemplateFeature,
            ConversationHelperTemplateFeature,
            DialogueTemplateFeature,
            AudienceInputTemplateFeature,
        ]),
    ]),
    SECTION(t('Channels'), [ChannelSelectionFeature]),
];

export const editorialDashDefaultConfig = {
    spaces: true,

    // Templates
    'comment-slider-template': true,
    'representing-perspectives-template': true,
    'conversation-helper-template': false, // Labs feature
    'dialogue-template': true,
    'audience-input-template': true,
};
